import { SHAPE_STROKE_PROPS } from './stroke-props';

interface DiamondProps {
  strokeDasharray: string | undefined;
}

export default function Diamond({ strokeDasharray }: DiamondProps) {
  return (
    <path
      d="M 50 0 L 100 50 L 50 100 L 0 50 Z"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
